import Vue from 'vue'
import VueI18n from 'vue-i18n'
const messages = {
    en: {
      message: {
        hello: 'hello world'
      }
    }
  }
import axios from 'axios'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en',
    messages // set locale messages
  })

  
  function setI18nLanguage (lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
  }
  
  export function setLanguage(lang, messages) {
    i18n.setLocaleMessage(lang, { message: messages })
    return setI18nLanguage(lang)
  }